import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

interface AuditLogItem {
  id: string; occurredAt: string; actorType: string;
  actorUserId: string | null; actorEmail: string | null;
  action: string; targetType: string; targetId: string | null; payloadJson: string;
}
interface AuditLogListResponse { items: AuditLogItem[]; totalCount: number; }

export default function AdminAuditLog() {
  const [action, setAction] = useState("");
  const [targetType, setTargetType] = useState("");

  const log = useQuery({
    queryKey: ["audit-log", action, targetType],
    queryFn: () => api.get<AuditLogListResponse>("/admin/audit-log", {
      params: { action: action || undefined, targetType: targetType || undefined, pageSize: 200 },
    }).then((r) => r.data),
  });

  return (
    <main className="mx-auto max-w-6xl p-6">
      <h1 className="mb-4 text-2xl font-bold text-brand-ink">Audit log</h1>

      <div className="mb-4 flex flex-wrap gap-2">
        <input className="field-input max-w-xs" placeholder="Filter by action (e.g. quiz.publish)"
          value={action} onChange={(e) => setAction(e.target.value)} />
        <input className="field-input max-w-xs" placeholder="Filter by target type (e.g. Quiz)"
          value={targetType} onChange={(e) => setTargetType(e.target.value)} />
      </div>

      <div className="card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-brand-light text-brand-ink">
              <tr>
                {["When", "Actor", "Action", "Target", "Payload"].map((h) => (
                  <th key={h} className="px-3 py-2 text-left font-semibold">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {log.data?.items.map((row) => (
                <tr key={row.id} className="border-t border-brand-ink/10 align-top">
                  <td className="whitespace-nowrap px-3 py-2 text-xs text-brand-ink/70">
                    {new Date(row.occurredAt).toLocaleString()}
                  </td>
                  <td className="px-3 py-2 text-xs">
                    <div>{row.actorEmail ?? "—"}</div>
                    <div className="text-brand-ink/50">{row.actorType}</div>
                  </td>
                  <td className="px-3 py-2 font-mono text-xs">{row.action}</td>
                  <td className="px-3 py-2 text-xs">
                    <div>{row.targetType}</div>
                    {row.targetId && <div className="text-brand-ink/50">{row.targetId}</div>}
                  </td>
                  <td className="px-3 py-2">
                    <pre className="max-w-md overflow-x-auto whitespace-pre-wrap text-xs text-brand-ink/70">
                      {row.payloadJson}
                    </pre>
                  </td>
                </tr>
              ))}
              {log.data?.items.length === 0 && (
                <tr><td colSpan={5} className="px-3 py-6 text-center text-brand-ink/60">
                  No matching audit events.
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
}
